// -----------------------------------------------------------------------------
// Home
// -----------------------------------------------------------------------------

import swal from '../../../js/sweetalert.min.js'; // eslint-disable-line new-cap

const init = () => {
  if ($('.js-body').hasClass('js-body-profile-view') === false) {
    return;
  }

  initEventListeners();
};

/**
 * AJAX einrichten
 */
const initEventListeners = () => {
  const $body = $('.js-body');
  const basepath = $body.attr('data-basepath');

  const $container = $('.js-app-profile-view');
  const vars = JSON.parse(document.querySelector('.js-body-profile-view #vars').textContent);
  const trans = JSON.parse(document.querySelector('.js-body-profile-view #trans').textContent);

  // -----------------------------------------------------------------------------
  // Zu Favoriten hinzufügen
  // -----------------------------------------------------------------------------

  $container.on('click', '.addFav', function (e) {
    e.preventDefault();

    $('.favstar').css('background-color', '#0099ff');
    $('.favtext').html(trans.favorit_entfernen);
    $(this).addClass('removeFav');
    $(this).removeClass('addFav');
    $.ajax({
      url: `${basepath}/profile/${vars.USR_hashUnique}/addfav`,
      method: 'GET'
    });
  });

  // -----------------------------------------------------------------------------
  // Von Favoriten entfernen
  // -----------------------------------------------------------------------------

  $container.on('click', '.removeFav', function (e) {
    e.preventDefault();

    $('.favstar').css('background-color', '#e1197d');
    $('.favtext').html(trans.favorit_hinzufuegen);
    $(this).addClass('addFav');
    $(this).removeClass('removeFav');
    $.ajax({
      url: `${basepath}/profile/${vars.USR_hashUnique}/removefav`,
      method: 'GET'
    });
  });

  // -----------------------------------------------------------------------------
  // Nachricht senden
  // -----------------------------------------------------------------------------

  $('.writeMsg').click(function (e) {
    e.preventDefault();

    swal({ // eslint-disable-line new-cap
      title: trans.ihre_nachricht,
      content: 'input',
      showCancelButton: true,
      buttons: [trans.abbrechen, trans.nachricht_absenden]
    }).then(function (result) {
      if (result) {
        $.ajax({
          url: vars.LNKsendmsg,
          method: 'POST',
          data: {
            id: vars.USR_hashUnique,
            text: result,
            CSRF_token: $('.js-csrf-token-writeMsg').val()
          }
        })
          .done(function () {
            swal('', trans.ihre_nachricht_an_x_wurde_uebermittelt, 'success'); // eslint-disable-line new-cap
          })
          .fail(function () {
            swal('', trans.ihre_nachricht_konnte_nicht_zugestellt_werden, 'error'); // eslint-disable-line new-cap
          });
      }
    });
  });

  // -----------------------------------------------------------------------------
  // Verstoß melden
  // -----------------------------------------------------------------------------

  $('.reportMsg').click(function (e) {
    e.preventDefault();

    swal({ // eslint-disable-line new-cap
      title: trans.warum_wollen_sie_einen_verstoss_melden,
      content: 'input',
      buttons: [trans.abbrechen, trans.nachricht_absenden]
    }).then(function (result) {
      if (result) {
        $.ajax({
          url: vars.LNKsreportuser,
          method: 'POST',
          data: {
            id: vars.USR_hashUnique,
            text: result,
            CSRF_token: $('.js-csrf-token-reportMsg').val()
          }
        })
          .done(function () {
            swal('', trans.ihre_meldung_wurde_uebermittelt, 'success'); // eslint-disable-line new-cap
          })
          .fail(function () {
            swal('', trans.ihre_nachricht_konnte_nicht_zugestellt_werden, 'error'); // eslint-disable-line new-cap
          });
      }
    });
  });
};

export {
  init
};
